import {
  ShieldCheck,
  ArrowCounterClockwise,
  FileText,
  Lock,
  Info,
  CheckCircle,
  XCircle,
  ArrowLeft,
  Storefront,
  Truck,
  HardHat
} from "@phosphor-icons/react";
import { Link, useNavigate } from "react-router-dom";
import React, { useEffect } from "react";

export default function SupportPage() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const sections = [
    {
      icon: CheckCircle,
      title: "Do's & Don'ts Guidelines",
      description: "Practical guidance for Sellers, Delivery Partners, and Customers to keep Loado deliveries safe, compliant, and efficient.",
      to: "/dos-donts",
    },
    {
      icon: ArrowCounterClockwise,
      title: "Return, Refund & Cancellation Policy",
      description: "Learn how cancellations, refunds, and logistics liabilities are handled across the Loado marketplace.",
      to: "/refund-policy",
    },
    {
      icon: Lock,
      title: "Privacy Policy",
      description: "Understand how Loado collects, protects, and shares sensitive information for partners, sellers and customers.",
      to: "/privacy-policy",
    },
    {
      icon: FileText,
      title: "Terms & Conditions",
      description: "Read the terms that govern platform use for logistics booking and material marketplace services.",
      to: "/terms-conditions",
    },
    {
      icon: Info,
      title: "About Us",
      description: "Learn about Loado's mission, values and the construction ecosystem we are building for India.",
      to: "/about-us",
    },
  ];

  return (
    <div className="min-h-screen pt-20 lg:pt-24 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <button
          onClick={() => navigate("/")}
          data-testid="back-to-home"
          className="flex items-center gap-2 text-slate-600 hover:text-slate-900 mb-8 transition-colors"
        >
          <ArrowLeft size={20} weight="bold" />
          <span className="font-medium">Back to Home</span>
        </button>

        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 mb-4">
            <ShieldCheck size={20} weight="duotone" className="text-[#0055FF]" />
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[#0055FF]">
              Support & Compliance
            </span>
          </div>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black text-[#0F172A] mb-4">
            We've Got You Covered
          </h1>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Transparent policies, clear guidelines, and dedicated support for all your needs.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-[#0F172A] mb-6">Policies & Information</h2>
          <div className="grid gap-4">
            {sections.map((section, index) => (
              <Link
                key={index}
                to={section.to}
                className="group block border border-slate-200 rounded-3xl bg-white p-6 transition hover:border-[#0055FF] hover:shadow-sm"
              >
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-2xl bg-slate-100 flex items-center justify-center text-[#0055FF]">
                    <section.icon size={24} weight="duotone" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-[#0F172A]">{section.title}</h3>
                    <p className="mt-2 text-slate-600">{section.description}</p>
                  </div>
                </div>
                <div className="mt-6 flex items-center justify-between text-sm font-semibold text-[#0055FF]">
                  <span>Read full section</span>
                  <span className="transition-transform duration-200 group-hover:translate-x-1">→</span>
                </div>
              </Link>
            ))}
          </div>
        </div>

        <div className="mt-12 text-center p-6 bg-slate-50 rounded-lg border border-slate-200">
          <p className="text-slate-600 mb-4">Need more help? Reach out to our support team.</p>
          <button
            onClick={() => navigate("/contact")}
            data-testid="go-to-contact"
            className="px-6 py-3 bg-[#0055FF] text-white font-semibold hover:bg-[#0044CC] transition-colors"
          >
            Contact Us
          </button>
        </div>
      </div>
    </div>
  );
}
